import React from 'react';

import {
  Box,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';

import strings from '../../../localization';

import styles from './styles';

interface IConversationHeader {
  isConnected: boolean;
  onBack: () => void;
  statusLabel: string;
}

const ConversationHeader = ({
  isConnected,
  onBack,
  statusLabel,
}: IConversationHeader) =>
  (
    <>
      <Box sx={styles.header}>
        <Tooltip title={strings.back}>
          <IconButton
            aria-label={strings.back}
            onClick={onBack}
            sx={styles.backButton}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>

        <Box sx={styles.agentOrb}>
          <AutoAwesomeRoundedIcon sx={styles.agentOrbIcon} />
        </Box>
        <Box sx={styles.headerText}>
          <Typography sx={styles.headerTitle}>
            {strings.aiCompanion}
          </Typography>
          <Typography sx={styles.headerSubtitle}>
            {strings.aiCompanionProfileAssistant}
          </Typography>
        </Box>
        <Box sx={styles.statusContainer}>
          <Box
            component="span"
            sx={[
              styles.statusDot,
              isConnected ? styles.statusDotConnected : {},
            ]}
          />
          <Typography sx={styles.status}>{statusLabel}</Typography>
        </Box>
      </Box>

      <Divider />
    </>
  );

export default ConversationHeader;
